import { render, staticRenderFns } from "./schoolViewEdit.vue?vue&type=template&id=36bc161c"
import script from "./schoolViewEdit.vue?vue&type=script&lang=js"
export * from "./schoolViewEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bc161c')) {
      api.createRecord('36bc161c', component.options)
    } else {
      api.reload('36bc161c', component.options)
    }
    module.hot.accept("./schoolViewEdit.vue?vue&type=template&id=36bc161c", function () {
      api.rerender('36bc161c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/schoolViewEdit.vue"
export default component.exports